export default __webpack_public_path__ + "static/media/doctor.8ce70da9.svg";